const actions = {
  SET_STATE: 'pages/company/aerochex/SET_STATE',
};

export default actions;
